import { createApp } from 'vue';
import * as Sentry from '@sentry/vue';
import router from './routes';
import config from '@/config';

import i18n from '@/i18n';
import vuetify from '@/plugins/vuetify';
import UIService from '@/components/ui/ui-service';
import Modal from '@/components/ui/ui-modal/modal/modal.vue';
import ErrorAggregator from '@/components/global/error-aggregator.vue';
import { install as RecaptchaV2Install } from 'vue3-recaptcha-v2';

import VueVirtualScroller from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import HighchartsVue from 'highcharts-vue';

import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';
import { setupCalendar, DatePicker } from 'v-calendar';
import 'v-calendar/style.css';


import { createPinia } from 'pinia';
import { useStore } from '@/store';

import '@fortawesome/fontawesome-pro/css/all.min.css';
import '@/styles/global/index.scss';
import App from './App.vue';
import mixpanel from 'mixpanel-browser';

const app = createApp(App)

app.use(createPinia());
const store = useStore();

if (import.meta.env.VUE_APP_MODE !== 'cypress') {
  mixpanel.init(config.mixpanel, {
    track_pageview: false,
  }, null);

  if (store.impersonation?.id) {
    mixpanel.disable();
  }
}

app.use(i18n)
app.use(vuetify)
app.use(UIService)
app.component('modal', Modal)
app.component('ErrorAggregator', ErrorAggregator)
app.use(router)

app.use(VueVirtualScroller);
app.use(HighchartsVue);
app.use(ToastPlugin);
app.use(setupCalendar, {});
app.component('vc-date-picker', DatePicker);
app.use(RecaptchaV2Install, { sitekey: config.recaptchaKey });

// click-outside-bemob: call binding value when click happens outside the element
app.directive('click-outside-bemob', {
  mounted(el: HTMLElement, binding: { value: () => void }) {
    const handler = (e: MouseEvent) => {
      if (el && !el.contains(e.target as Node)) binding.value?.();
    };
    (el as any).__clickOutsideBemob = handler;
    document.addEventListener('click', handler);
  },
  unmounted(el: HTMLElement) {
    const handler = (el as any).__clickOutsideBemob;
    if (handler) document.removeEventListener('click', handler);
  }
});


Sentry.init({
  app,
  dsn: 'https://f5784c85c2d8f06fae1f2ca1921d9450@o4509434140426240.ingest.us.sentry.io/4509434144030720',
  sendDefaultPii: true,
  environment: import.meta.env.VUE_APP_CONFIG_NAME || import.meta.env.MODE
});


router.isReady().then(() => {
  app.mount('#application');
});

export default app;
